import { useQuery } from 'react-query';
import { getUserContent } from 'App/services/ReportEngineService';
import * as R from 'ramda';

function useFetchUserInsightsContent() {
    return useQuery(
        ['insights', 'user'],
        () =>
            getUserContent().then(
                R.compose(
                    R.over(R.lensProp('userLooks'), R.sortBy(R.prop('title'))),
                    R.over(R.lensProp('userDashboards'), R.sortBy(R.prop('title'))),
                    R.over(R.lensProp('companyDashboards'), R.sortBy(R.prop('title'))),
                    R.over(R.lensProp('companyLooks'), R.sortBy(R.prop('title')))
                )
            ),
        {
            retry: 2,
            refetchInterval: false,
            refetchOnWindowFocus: false,
            retryDelay: 5000,
        }
    );
}

export default useFetchUserInsightsContent;
